import React from 'react'
import Divider from '../Divider'
import Icon from '../Icon'
import { StyledTable, StyledTableContainer, StyledTableHead, StyledTableBody, StyledTableRow, StyledLink, StyledTableCell, StyledTableCellIcon } from './styled'

const Table = ({ columns, sortOrder, sort, data, divider, minWidth = 'auto', hover, onClickRow, onClickHeaderCell, to }) => {
    const handleClickHeaderCell = (sortColumn) => () => {
        const { enabled, ...rest } = sortColumn;
        if(enabled) {
            onClickHeaderCell && onClickHeaderCell(rest);
        }
    }
    const getData = () => {
        if(data && sort) {
            return sort(data);
        } else if(data) {
            return data;
        } else {
            return [];
        }
    }
    return (
        <StyledTable>
            <StyledTableContainer style={{ minWidth }}>
                <StyledTableHead>
                    <StyledTableRow>
                        {
                            columns &&
                            columns.map(({ key, name, style = {}, sort : sortColumn = { direct: 'asc', key: 'order', enabled: false } }, columnIndex) => (
                                <StyledTableCell key={key || columnIndex} style={style} pointer={sortColumn.enabled} active={sortColumn.key === sortOrder.key} onClick={handleClickHeaderCell(sortColumn)}>
                                    {name}
                                    {
                                        sortColumn.key === sortOrder.key &&
                                        <StyledTableCellIcon sortDirect={sortOrder.direct}>
                                            <Icon name="arrowhead" />
                                        </StyledTableCellIcon>
                                    }
                                </StyledTableCell>
                            ))
                        }
                    </StyledTableRow>
                    {
                        divider &&
                        <Divider noMargin />
                    }
                </StyledTableHead>
                <StyledTableBody>
                    {
                        getData().map((item, itemIndex) => (
                            <React.Fragment key={item.number || itemIndex}>
                                <StyledTableRow hover={hover} onClick={onClickRow(item)}>
                                    {
                                        columns &&
                                        columns.map(({ key, cell, style = {} }, columnIndex) => (
                                            <StyledTableCell key={key || columnIndex} style={style}>
                                                {
                                                    (item[key] !== undefined && item[key] !== null) && (cell ? cell(item[key]) : item[key])
                                                }
                                                {
                                                    (item[key] === undefined || item[key] === null) && (cell ? cell() : '-')
                                                }
                                            </StyledTableCell>
                                        ))
                                    }
                                    {
                                        to &&
                                        <StyledLink to={to(item)} />
                                    }
                                </StyledTableRow>
                                {
                                    divider &&
                                    <Divider noMargin />
                                }
                            </React.Fragment>
                        ))
                    }
                </StyledTableBody>
            </StyledTableContainer>
        </StyledTable>
    )
}

Table.defaultProps = {
    sortOrder: {
        key: "",
        direct: ""
    },
    onClickRow: () => { }
}

export default Table
